export default "__VITE_PUBLIC_ASSET__f45f694f__"